module.exports = __webpack_public_path__ + "a21be072bcdbb6b363d616f435d8045a.svg";